import { PublicClientApplication } from "@azure/msal-browser";
import { APP_ENV, AUTH_TOKEN_ROUTES, MSAL_CONFIG } from "../config";

const pca_config = {
  auth: {
    clientId: MSAL_CONFIG.CLIENT_ID,
    authority: MSAL_CONFIG.AUTHORITY,
    redirect: window.location.href,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const pca = new PublicClientApplication(pca_config);

export async function getBearerToken() {
  const tokenUrl = APP_ENV.LOCAL.includes(process.env.REACT_APP_RUN_ENV)
    ? AUTH_TOKEN_ROUTES.LOCAL
    : AUTH_TOKEN_ROUTES.REMOTE;
  const response = await fetch(tokenUrl);
  const data = await response.json();
  return data.token || "";
}
